import {
    instance as axios,
    setJwtToken,
  } from "../../config/axiosInstance";
  
export const formulaFeedingListApi = async (data) => {
  const endPoint = `admin/formula-feeding/list?${new URLSearchParams(
    data
  ).toString()}`;
  return await axios.get(endPoint, setJwtToken());
};
